import { jsx as _jsx } from "react/jsx-runtime";
import { VerificationType } from '../app/VerificationType';
import { GoogleOAuthButton } from '../google-authentication/GoogleOAuthButton';
import { googleLogin, microsoftLogin } from '../http-login/LoginClient';
import imageUrls from '../images/imageUrls';
import { MicrosoftButton } from '../microsoft/MicrosoftButton';
import { Data } from '../signup-data/DATA';
import { IdentityVerificationMethod } from '../tracking/IdentityVerificationMethod';
import { Step } from '../views/Step';
import { OAuthProviders } from './OAuthProviders';
export const OAuthToLogo = {
  [OAuthProviders.Microsoft]: imageUrls.microsoftLogo,
  [OAuthProviders.Wordpress]: imageUrls.wordpressLogo,
  [OAuthProviders.LinkedIn]: imageUrls.linkedinLogoWhite,
  [OAuthProviders.Apple]: imageUrls.appleLogoWhite,
  [OAuthProviders.PayPal]: imageUrls.paypalLogo
};
export const OAuthToText = {
  [OAuthProviders.Microsoft]: `views.${Step.LandingPage}.signupWithMicrosoft`,
  [OAuthProviders.Wordpress]: `views.${Step.LandingPage}.signupWithWordpress`,
  [OAuthProviders.LinkedIn]: `views.${Step.LandingPage}.signupWithLinkedIn`,
  [OAuthProviders.Apple]: `views.${Step.LandingPage}.signupWithApple`,
  [OAuthProviders.PayPal]: `views.${Step.LandingPage}.signupWithPayPal`
};
export const OAuthToComponent = {
  [OAuthProviders.Microsoft]: /*#__PURE__*/_jsx(MicrosoftButton, {}),
  [OAuthProviders.Google]: /*#__PURE__*/_jsx(GoogleOAuthButton, {})
};
export const OAuthToVerificationType = {
  [OAuthProviders.Google]: VerificationType.Google,
  [OAuthProviders.Microsoft]: VerificationType.Microsoft
};
export const OAuthToIdentityVerificationMethod = {
  [OAuthProviders.Google]: IdentityVerificationMethod.GoogleVerification,
  [OAuthProviders.Microsoft]: IdentityVerificationMethod.MicrosoftVerification
};
export const OAuthToDataToken = {
  [OAuthProviders.Google]: Data.GoogleIdToken,
  [OAuthProviders.Microsoft]: Data.MicrosoftLoginIdToken
};
export const OAuthToVerifyEndpoint = {
  [OAuthProviders.Google]: '/signup/v1/oauth/v2/google/verify',
  [OAuthProviders.Microsoft]: '/signup/v1/oauth/v1/microsoft/verify'
};
export const oAuthToLoginFunction = {
  [OAuthProviders.Google]: googleLogin,
  [OAuthProviders.Microsoft]: microsoftLogin
};